var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 3.33301V13.333L9.99992 11.6663L6.66659 13.333V3.33301M4.99992 16.6663H14.9999C15.4419 16.6663 15.8659 16.4907 16.1784 16.1782C16.491 15.8656 16.6666 15.4417 16.6666 14.9997V4.99967C16.6666 4.55765 16.491 4.13372 16.1784 3.82116C15.8659 3.5086 15.4419 3.33301 14.9999 3.33301H4.99992C4.55789 3.33301 4.13397 3.5086 3.82141 3.82116C3.50885 4.13372 3.33325 4.55765 3.33325 4.99967V14.9997C3.33325 15.4417 3.50885 15.8656 3.82141 16.1782C4.13397 16.4907 4.55789 16.6663 4.99992 16.6663Z",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.0d0cc0f5e97cfbce7e414b2ba7fc28be.svg";
export { ForwardRef as ReactComponent };